module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isActive) ? _c('div', {
    staticClass: "petition-form wwf-form light"
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('div', {
    staticClass: "petition-form"
  }, [(_vm.title) ? _c('h2', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.intro) ? _c('p', {
    staticClass: "form-intro",
    domProps: {
      "innerHTML": _vm._s(_vm.intro)
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.twitchName),
      expression: "twitchName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('twitchName')
    },
    attrs: {
      "name": "twitchName",
      "type": "text",
      "placeholder": "Twitch name"
    },
    domProps: {
      "value": (_vm.twitchName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.twitchName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'border-red': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    class: {
      'border-red': _vm.errors.has('phone')
    },
    attrs: {
      "name": "phone",
      "type": "number",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }],
    attrs: {
      "name": "postCode",
      "type": "number",
      "placeholder": "Postcode"
    },
    domProps: {
      "value": (_vm.postCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postCode = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Submit"
    },
    on: {
      "click": _vm.save
    }
  })])])]) : _vm._e(), _vm._v(" "), (!_vm.isActive) ? _c('div', {
    staticClass: "form-closed"
  }, [_c('p', [_vm._v(_vm._s(_vm.closingmessage))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-statement"
  }, [_c('p', [_vm._v("By signing you accept\n            "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("WWF-Australia’s Privacy Policy.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99393928","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=pnre6zws23l!./~/string-replace-webpack-plugin/loader.js?id=hfo8n7cvtpt!./src/components/TwitchForm.vue
// module id = 712
// module chunks = 0